import type { CheckoutTransportInfo } from '@/scopes/checkout/domain/types'

export function hasAnyExternalFlight(transportInfo?: CheckoutTransportInfo | null): boolean | null {
  if (!transportInfo)
    return null

  if (transportInfo.type !== 'flight')
    return null

  return transportInfo.details.some(detail => detail.isFlexible === false)
}
